var map = {
	"./001-facebook.png": 78,
	"./002-whatsapp.png": 280,
	"./003-github.png": 257,
	"./Audiopile.png": 341,
	"./Screenshot (1).png": 971,
	"./Screenshot (2).png": 949,
	"./Screenshot (3).png": 576,
	"./Screenshot (4).png": 168,
	"./arabexpert.png": 40,
	"./arrow.png": 765,
	"./bookstore.png": 191,
	"./calc.png": 606,
	"./chatapp.png": 320,
	"./deplacemason.png": 702,
	"./green-dots.png": 496,
	"./linkedin.png": 267,
	"./my-img.webp": 773,
	"./newword.png": 93,
	"./photoeditor.png": 352,
	"./pomodoroapp.png": 734,
	"./simplegame.png": 669,
	"./starkcopy.png": 426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;